import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { Router } from '@angular/router';
import { UserRulesService } from 'src/app/shared/services/user-rules.service';
import { SearchObjectService } from '../../services/search-object.service';
import { PcpsService } from './../../services/pcps.service';

@Component({
  selector: 'app-select-location',
  templateUrl: './select-location.component.html',
  styleUrls: ['./select-location.component.scss']
})
export class SelectLocationComponent implements OnInit {
  loading = false;
  showVirtualWarning = false;
  showDigitalWarning = false;
  bypassWarning = false;
  officeId;
  officeName;
  otherDoctorData;
  isDigitalMember;
  isVirtualCare;

  pcpValue = '';
  changePCPReason = '';
  error = '';
  isReferralAdmin = false;
  constructor(
    public _dialogRef: MatDialogRef<SelectLocationComponent>,
    private _userRulesService: UserRulesService,
    private pcpsService: PcpsService,
    private searchObjectService: SearchObjectService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
      this.isVirtualCare =this.data.detailData.locations[0].offersVirtualCareServices;
      this.otherDoctorData = this.data.otherDoctorData.practitioners;
      this.officeId = this.data.detailData.locations[0].officeId;
      this.officeName = this.data.detailData.locations[0].officeName;
  }

  ngOnInit() {
    this.showVirtualWarning = false;
    this.showDigitalWarning = false;
    this.bypassWarning = false;
    this.isDigitalMember = this.searchObjectService.getDigitalMember();
    this.showDigitalWarning = this.isDigitalMember && !this.isVirtualCare;
    for(const doctor of this.otherDoctorData) {
      if (doctor.offersVirtualCareServices) {
        this.showVirtualWarning = true;
      }
    }
    this.isReferralAdmin = this._userRulesService.isReferralAdmin();
  }
  onNoClick(): void {
    this._dialogRef.close();
  }
  onChangePcpValue($event: MatRadioChange) {
    this.checkValidity();
  }

  noDigitalContinue() {
    this.bypassWarning = true;
  }

  updatePCPReason(e) {
    this.changePCPReason = e.target.value;
    this.checkValidity();
  }

  checkValidity() {
    if (this.isReferralAdmin) {
      this.error = !this.changePCPReason || !this.pcpValue ? 'Please select a doctor and/or change reason and then click Save.' : '';
    } else {
      this.error = !this.pcpValue ? 'Please select a doctor and then click Save.' : '';
    }
  }

  pcpSave(): void {
    this.error = '';
    if (this.pcpValue !== '') {
      try {
        this.loading = true;
          if (!this._userRulesService.isExpired()) {
          this.pcpsService
            .savePcps(this.otherDoctorData[this.pcpValue].providerNumber, '', this.officeId, this.changePCPReason)
            .subscribe(data => {
              this.loading = false;
              this._dialogRef.close(this.otherDoctorData[this.pcpValue]);
            },
              error => {
                if (error.status === 500) {
                  this.error = 'We encountered an error when attempting to select your PCP. You may try again or you can select your PCP by calling Member Services at 1-855-489-3494.';
                } else if (error.error.message == 'Request of type PutPcpRequest is invalid' && error.error.errors && error.error.errors.length > 0) {
                  this.error = error.error.errors[0];
                } else {
                  this.error = 'We encountered an error when attempting to select your PCP. You may try again or you can select your PCP by calling Member Services at 1-855-489-3494.';
                }              
                this.loading = false;
              });
        }
      } catch {
        let referrer = this.isReferralAdmin ? 'Admin Portal' : 'UPMC Health Plan member site';
        this.error = `We can\'t select your PCP at this time because your session has expired. Please note this provider\'s name so you can try again by returning to ${referrer} and clicking the Select PCP link again.`;
        this.loading = false;
      }
    } else {
    this.error = this.isReferralAdmin ? 'Please select a doctor and/or change reason and then click Save.' : 'Please select a doctor and then click Save.';
     this.loading = false;
    }
  }

  goBacktoSearch() {
    this._dialogRef.close();
    if (this.searchObjectService.isValidSearchObject()) {
      this.searchObjectService.setSearchURL(true, this.searchObjectService.getLoginType());
    } else {
      this.router.navigate(['find']);
    }
  }
}
